import React, { useContext } from 'react'
import { IChannel } from 'shared/types/channel'
import ModalContext from '../context/modal'
import UserContext from '../context/user'
import CollectionsEditor from '../edit-panel/collections-editor'
import { Modal } from '../modal'
import AddGifsToCollection from './add-gifs-to-collection'
import CollectionEditor from './editor'
import Header from './header'
import { Container, GifSelectorContainer } from './sc'

type ModalProps = {
    onClose: () => void
}

export type NewCollectionProps = {
    userId: number
    parentChannel: IChannel
    redirectOnCreate?: boolean
}

export const NewCollectionModal = ({
    onClose,
    newCollectionProps,
}: ModalProps & {
    newCollectionProps: NewCollectionProps
}) => {
    return (
        <Modal>
            <Container>
                <Header title="New Collection" onClose={onClose} />
                <CollectionEditor newCollectionProps={newCollectionProps} onComplete={onClose} />
            </Container>
        </Modal>
    )
}

export const ChannelGifSelector = ({
    onClose,
    channelId,
    searchChannelId,
}: ModalProps & {
    channelId: number
    searchChannelId: number
}) => {
    return (
        <Modal>
            <GifSelectorContainer>
                <Header title="Your Channel" onClose={onClose} />
                <AddGifsToCollection channelId={channelId} onComplete={onClose} searchChannelId={searchChannelId} />
            </GifSelectorContainer>
        </Modal>
    )
}

export const EditCollectionModal = ({
    onClose,
    channel,
}: ModalProps & {
    channel: IChannel
}) => {
    return (
        <Modal>
            <Container>
                <Header title="Edit Collection" onClose={onClose} />
                <CollectionEditor channel={channel} onComplete={onClose} />
            </Container>
        </Modal>
    )
}

type CabinetProps = { channelId?: number } & ModalProps
export const CollectionCabinetModal = ({ onClose, channelId }: CabinetProps) => {
    const { user } = useContext(UserContext)
    const { openAddGifsToCollectionPanel } = useContext(ModalContext)
    const id = channelId || user.channelId
    return (
        <Modal>
            <Container>
                <Header title="Collection Cabinet" onClose={onClose} />
                <CollectionsEditor
                    channelId={id}
                    onAdd={(channelId: number, searchChannelId: number) =>
                        openAddGifsToCollectionPanel(channelId, searchChannelId)
                    }
                    onDelete={channel => {
                        console.log({ delete_channel: channel })
                        // setChannels(editModeChannels.filter(c => c.id !== channel.id))
                    }}
                />
            </Container>
        </Modal>
    )
}
